import { Controller } from "@hotwired/stimulus";

// Mirrors the visible "reason" textarea into hidden reason inputs in the
// modal's other form(s), so the reason is submitted whichever button is used.
export default class extends Controller {
  static targets = ["source", "field"];

  sync() {
    this.fieldTargets.forEach((field) => {
      field.value = this.sourceTarget.value;
    });
  }
}
